import React from "react";
import { connect } from "react-redux";

import {
  Status,
  Protocol,
  //  ErrorTypes,
  Globals,
} from "./lib/constants";
import { MessageFactory } from "./lib/messages";
import GameUtils from "./lib/gameutils";
import { MessagesList } from "./lib/keno_msg";
import { WS } from "./lib/websocket";
import { AppContainer } from "./AppStyled";

import { placeBet } from "./lib/socketMessages";
import { stringToObjSettings } from "./components/otherPages/settings/saveSettings/stringToObj/stringToObjSettings";
import {
  handleGameState,
  handleBetInfo,
  toggleChangingMode,
  handleSettings,
  handleAutoRulesConfigs,
  handleBet,
  saveSettings,
  getSeedsResponce,
  handleBetReplay,
} from "./redux/actions/postActions";

// import Fullscreen from "react-full-screen";

import Keno from "./components/keno/keno";
import Loading from "./components/otherPages/loading/Loading";
import Notification from "./components/otherPages/notifications/Notification";

import { NoSignal } from "./components/otherPages/noSignal/NoSignal";
import AutoRollLogic from "./components/keno/auto/autoroll";

export const logger = {
  isEnabled: true,
  log: function (...args) {
    if (this.isEnabled) {
      // console.log(...args);
    }
  },
};

class App extends React.Component {
  constructor(props) {
    super(props);
    // this.WS_URL = "wss://test.orbitalgaming.io/websocketbridge/ws/test-keno";
    this.WS_URL = "{{SERVER_WS_URL}}";
    this.hostname = window.location.hostname
    if (this.hostname === 'localhost') {
      this.WS_URL = 'wss://dev.orbitalgaming.io/websocketbridge/ws/keno'
      // this.WS_URL = 'wss://test.orbitalgaming.io/websocketbridge/ws/keno'
    } else if (this.WS_URL.includes('SERVER_WS_URL')) {
      this.WS_URL = `wss://${this.hostname}/websocketbridge/ws/keno`
    }

    this.state = {
      isLoaded: false,
      startKeno: false,
      fadeInKeno: true,
      showLoading: true,
      isShakingPurple: false,
      isShaking: false,
      coordinates: {},
      user_id: null,
      maxBet: 100,
      minBet: '0',
      gameMode: undefined,
      gameState: {},
      selected: [],
      betInfo: {
        selectedNumbers: [],
        numbers: [],
        winNumbers: [],
        balance: null,
        winAmount: null,
        winMult: null,
        betAmount: "0.1",
        currency: "",
      },

      isAutoOn: false,
      makeClickable: false,

      noSignal: false,
      errorMsg: "",
      errorBtn: "",
      reload: false,

      notification: false,
      notificationfadeOut: false,

      stats: {
        all_stats: [],
        my_stats: [],
        big_stats: [],
      },

      myHistory: [],
      allHistory: [],
      highRoller: [],

      autoRulesConfigs: {
        numberOfBets: "1",
        onWinPercent: "2",
        onLossPercent: "3",
        stopOnProfit: "4",
        stopOnLoss: "5",
      },

      sound: true,
      music: true,
      volume: null,

      scrollable: false,

      lastWidth: window.innerWidth,
      lastHeight: window.innerHeight,
      intViewportHeight: window.innerHeight,

      rotateNow: false,
      betReplyData: {},
    };
    this.everyHistory = [];
    this.myHistoryLocal = [];
    this.allHistoryLocal = [];
    this.highRollerLocal = [];
    this.autorollLogic = new AutoRollLogic();
    this.myTimeout = null;
    this.notificationTimeOut = null;
  }

  componentDidMount() {
    console.log("%cV2.0.1 CG", "background: green; font-size: 16px")
    window._mfq = window._mfq || [];
    (function () {
      var mf = document.createElement("script");
      mf.type = "text/javascript";
      mf.defer = true;
      mf.src =
        "https://cdn.mouseflow.com/projects/27d3415e-736e-4ff5-9a5c-1aa7729b351d.js";
      document.getElementsByTagName("head")[0].appendChild(mf);
    })();

    MessageFactory.messagesList = MessagesList;
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    setTimeout(() => {
      this.setState({ isLoaded: true })
    }, 1000)
    if (this.WS_URL.includes('orbitalgaming.com')) {
      console.clear()
      logger.isEnabled = false
    }
  }
  componentWillUnmount() {
    Globals.WS.Disconnect();
  }
  componentDidUpdate() {
    if (!this.props.changingMode && !!this.state.user_id) {
      this.setState({ user_id: null });
    }

    // change audio, from redux to app.state
    const { music: musicS, sound: soundS } = this.state;
    const { music, sound } = this.props.audio;
    if (musicS !== music) this.setState({ music });
    if (soundS !== sound) this.setState({ sound });
    logger.log(this.WS_URL, 'this.WS_URL')
  }
  setStatus(status) {
    logger.log("%cstatus = ", "color:brown", status);
    switch (status) {
      case Status.CONNECTED:
        logger.log("%cconnected ", "color:green");
        this.setState({ noSignal: false, reload: false });
        this.props.toggleChangingMode(true);
        logger.log(this.props.gameMode, 'mode')
        var session = GameUtils.getParameterByName("session");
        if (typeof session == "string") {
          let mode = "40";
          if (this.props.gameMode === "80") mode = "80";
          this.setState({ gameMode: this.props.gameMode });
          var loginMsg = MessageFactory.createMessage(
            Protocol.LOGIN,
            GameUtils.getParameterByName("session") + "@1",
            mode,
          );
          Globals.WS.sendMessage(loginMsg);
        } else {
          // TODO : not logged in`
          logger.log("not logged in");
        }

        break;
      case Status.DISCONNECTED:
        this.setState({
          noSignal: true,
          notification: false,
          above: false,
          errorMsg: `Your session has expired, please reload the page to continue`,
          reload: true,
          errorBtn: false,
        });

        clearTimeout(this.myTimeout);

        break;
      default:
        break;
    }
  }


  doMessage = function (msg) {
    var msgObject = null;
    try {
      msgObject = MessageFactory.parseMessage(msg);
    } catch (e) {
      logger.dir(e);
    }
    // logger.log("vvvvv INCOMING MSG vvvvv ", msgObject.type);
    if (msgObject === null) {
      //error unknown message
      logger.log("doMessage msgObject === null ", msg);
      return;
    }

    switch (msgObject.type) {
      case Protocol.BET_INFO:
        logger.log("%cBET_INFO", "color:aqua;font-size: medium", msgObject);
        this.setState({ betInfo: msgObject });
        this.props.handleBetInfo(msgObject); // dzaan ar momwons TODO
        let { autorollLogic, clearWonBalls, handleNotification } = this;
        const setState = this.setState.bind(this);
        const { selected, isAutoOn, gameMode, maxBet, minBet, toFix } =
          this.state;
        const currency = this.state.gameState.currency;
        const { winAmount, betAmount, balance } = msgObject;
        let time = 800;
        if (gameMode === "40") time = 5500;
        if (gameMode === "80") time = 8800;
        if (isAutoOn) {
          this.myTimeout = setTimeout(function () {
            let value = autorollLogic.nextStep(winAmount - betAmount);
            if (+autorollLogic.bet > maxBet) {
              handleNotification("Max bet limit is " + maxBet);
              setState({
                isAutoOn: false,
              });
              return;
            }
            if (+autorollLogic.bet < minBet) {
              handleNotification("Min bet is " + minBet);
              setState({
                isAutoOn: false,
              });
              return;
            }

            if (+autorollLogic.bet > balance) {
              handleNotification("Not enough balance");

              setState({
                isAutoOn: false,
              });
              return;
            }
            switch (value) {
              case AutoRollLogic.ROLL_OK:
                clearWonBalls();
                // Globals.WS.sendMessage(
                //   MessageFactory.createMessage(
                //     Protocol.BET,
                //     +autorollLogic.bet,
                //     selected.join(":")
                //   )
                // );
                placeBet(+autorollLogic.bet, selected.join(":"));
                break;
              case AutoRollLogic.ROLL_STOP_ON_LOSS:
                handleNotification(
                  `Stopped on loss - ${(+autorollLogic.ggr).toFixed(
                    toFix,
                  )} ${currency}`,
                );
                setState({
                  isAutoOn: false,
                });
                break;
              case AutoRollLogic.ROLL_STOP_ON_WIN:
                handleNotification(
                  `Stopped on  win - ${(+autorollLogic.ggr).toFixed(
                    toFix,
                  )} ${currency}`,
                );
                setState({
                  isAutoOn: false,
                });
                break;
              case AutoRollLogic.ROLL_STOP_ON_NUMBETS:
                handleNotification("Stopped on a selected number of bets");
                setState({
                  isAutoOn: false,
                });
                break;

              default:
                break;
            }
          }, time);
        }
        break;
      case Protocol.BET_INFO_ALL:
        logger.log(
          "%cBET_INFO_ALL",
          "color:aqua;font-size: medium",
          msgObject,
        );
        break;
      case Protocol.HISTORY:
        // logger.log("%cHISTORY","color:aqua;font-size: medium", msgObject);
        let timeout = 300;
        if (this.state.gameMode === "40") timeout = 4400;
        if (this.state.gameMode === "80") timeout = 8800;

        setTimeout(() => {
          if (
            this.everyHistory.some((el) => el.round_id === msgObject.round_id)
          ) {
            // logger.log("already in this.everyHistory");
            return;
          }
          this.everyHistory.unshift(msgObject);
          this.allHistoryLocal.unshift(msgObject);
          while (this.allHistoryLocal.length > 18) {
            this.allHistoryLocal.pop();
          }
          // my bets
          if (msgObject.user_id === this.state.user_id) {
            this.myHistoryLocal.unshift(msgObject);
            while (this.myHistoryLocal.length > 18) {
              this.myHistoryLocal.pop();
            }
          }

          // high rollers
          if (msgObject.bigWin === 2) {
            this.highRollerLocal.unshift(msgObject);
            while (this.highRollerLocal.length > 18) {
              this.highRollerLocal.pop();
            }
          }

          this.setState({
            allHistory: this.allHistoryLocal,
            myHistory: this.myHistoryLocal,
            highRoller: this.highRollerLocal,
          });
        }, timeout);

        break;
      case Protocol.USER_SETTINGS_RESPONCE:
        logger.log(
          "%cUSER_SETTINGS_RESPONCE",
          "color:aqua; font-size: medium",
          msgObject.settings,
        );
        let settingsObj = stringToObjSettings(msgObject.settings);
        let { music, sound, volume } = settingsObj.audio;
        this.setState({
          music,
          sound,
          volume,
        });


        // // bet update
        let betInf2 = this.state.betInfo;

        //#region  Loading
        if (!this.state.isLoaded) {
          const yellow = document.getElementsByClassName("yellow")[0];
          const orange = document.getElementsByClassName("orange")[0];
          const white = document.getElementsByClassName("white")[0];
          const purple = document.getElementsByClassName("purple")[0];

          const yl = yellow.offsetLeft;
          const yt = yellow.offsetTop;
          const ol = orange.offsetLeft;
          const ot = orange.offsetTop;
          const wl = white.offsetLeft;
          const wt = white.offsetTop;
          const pl = purple.offsetLeft;
          const pt = purple.offsetTop;
          this.setState({
            betInfo: betInf2,
            gameMode: msgObject.settings.split(";")[0],
            isLoaded: true,

            coordinates: { yl, yt, ol, ot, wl, wt, pl, pt },
          });
          setTimeout(() => {
            this.setState({ isShaking: true });
          }, 1000);
          setTimeout(() => {
            this.setState({ isShakingPurple: true });
          }, 1500);
          // this.props.handleSettings(msgObject.settings);
        }
        //#endregion
        this.props.handleSettings(settingsObj);
        break;

      case Protocol.GET_ROUND_RESPONCE:
        logger.log(
          "%cGET_ROUND_RESPONCE",
          "color:aqua;font-size: medium",
          msgObject,
        );
        // this.props.handleBetReplay(msgObject);
        // this.setState({ betReplyData: msgObject });
        this.handleBetReply(msgObject);

        break;
      case Protocol.GET_SEEDS_RESPONCE:
        logger.log(
          "GET_SEEDS_RESPONCE",
          "color:aqua;font-size: medium",
          msgObject,
        );

        this.props.getSeedsResponce(msgObject); //reduxshi unda daapdeitdes
        // this.setState({ provablyFairSeeds: msgObject });
        break;

      case Protocol.GET_STATS_RESPONCE:
        logger.log("%cGET_STATS_RESPONCE", "color:aqua", msgObject);
        this.setState({ stats: msgObject });
        // this.props.addInStatsForChart(msgObject);
        break;
      case Protocol.GAME_STATE:
        logger.log("%cGAME_STATE", "color:aqua;font-size: medium", msgObject);
        this.props.handleGameState(msgObject);
        let betInf = this.state.betInfo;
        betInf.balance = msgObject.balance;
        this.setState({
          betInfo: betInf,
          user_id: msgObject.user_id,
          gameState: msgObject,
          toFix: msgObject.afterDot,
        });
        setTimeout(() => {
          this.setState({ startKeno: true });
        }, 600);
        setTimeout(() => {
          this.setState({ showLoading: false, fadeInKeno: false });
        }, 2000);
        break;

      case Protocol.ERROR:
        console.error("doMessage error read " + msgObject.errorCode);
        switch (msgObject.errorCode) {
          case 1:
            console.error("CONCURRENT_CONNECTION");
            this.setState({
              errorMsg: "Concurrent  Connection",
              errorBtn: "Reload",
              noSignal: true,
              reload: true,
            });
            break;
          case 2:
            console.error("INVALID_SESSION");
            this.setState({
              errorMsg: "Invalid Session",
              errorBtn: false,
              noSignal: true,
              reload: true,
            });
            break;
          case 3:
            console.error("INSUFFICIENT_FUNDS", msgObject);
            this.handleNotification("Not enough balance");
            this.setState({ makeClickable: true });
            setTimeout(() => {
              this.setState({ makeClickable: false });
            }, 1000);
            if (this.state.isAutoOn) {
              this.setState({ isAutoOn: false });
              clearTimeout(this.myTimeout);
            }
            this.toggleIsAutoOn(false)
            break;
          case 4:
            console.error("INVALID_BET_AMOUNT", msgObject);
            this.handleNotification("Invalid bet amount");
            this.setState({ makeClickable: true });
            logger.log(this.state.makeClickable, 'makeClickable')
            setTimeout(() => {
              this.setState({ makeClickable: false });
            }, 1000);
            if (this.state.isAutoOn) {
              this.setState({ isAutoOn: false });
              clearTimeout(this.myTimeout);
            }
            break;
          case 5:
            console.error("MONEY_TRANSFER_ERROR", msgObject);
            this.setState({
              errorMsg: "Something went wrong, please reload the page",
              errorBtn: false,
              noSignal: true,
              reload: true,
            });

            break;
          case 6:
            console.error("INVALID_BET", msgObject);
            this.handleNotification("Invalid bet amount");
            this.setState({ makeClickable: true });
            logger.log(this.state.makeClickable, 'makeClickable')
            setTimeout(() => {
              this.setState({ makeClickable: false });
            }, 1000);
            if (this.state.isAutoOn) {
              this.setState({ isAutoOn: false });
              clearTimeout(this.myTimeout);
            }
            break;
          case 7:
            console.error("PF_NOT_SET", msgObject);
            this.setState({
              errorMsg: "Provably fair seed is not set",
              errorBtn: "Reconnect",
              noSignal: true,
              reload: false,
            });
            break;
          case 8:
            console.error("CLIENT_SEED_ERROR", msgObject);
            break;
          case 9:
            console.error("CLIENT_SEED_OK", msgObject);
            this.handleNotification("Provably fair seed set successfully");
            break;
          case 10:
            console.error("SYSTEM_ERROR", msgObject);
            this.setState({
              errorMsg: "Something Went Wrong, reload the page if necessary",
              errorBtn: false,
              noSignal: true,
              reload: false,
            });
            break;
          case 11:
            console.error("INVALID_ACTION", msgObject);
            this.handleNotification("Invalid action");
            this.toggleIsAutoOn(false)
            break;
          case 13:
            console.error("NOT_FOUND", msgObject);
            break;
          case 14:
            console.error("GAME_NOT_ACTIVE", msgObject);
            this.setState({
              errorMsg: "Game is not active, reload the page if necessary",
              errorBtn: false,
              noSignal: true,
            });
            break;
          case 16:
            console.error("INSUFFICIENT_FUNDS", msgObject);
            this.handleNotification("Not enough balance");
            this.setState({ makeClickable: true });
            setTimeout(() => {
              this.setState({ makeClickable: false });
            }, 1000);
            if (this.state.isAutoOn) {
              this.setState({ isAutoOn: false });
              clearTimeout(this.myTimeout);
            }
            this.toggleIsAutoOn(false)
            break;
          case 115:
            console.error("MAX_BET_LIMIT", msgObject);
            this.handleNotification("You have exceeded your betting limit");
            this.setState({ makeClickable: true });
            logger.log(this.state.makeClickable, 'makeClickable')
            setTimeout(() => {
              this.setState({ makeClickable: false });
            }, 1000);
            if (this.state.isAutoOn) {
              this.setState({ isAutoOn: false });
              clearTimeout(this.myTimeout);
            }
            break;
          default:
            console.error("SOMETHING WENT WRONG", msgObject);
            this.setState({
              errorMsg: "Something went wrong, reload the page if necessary",
              errorBtn: false,
              noSignal: true,
            });
            break;
        }
        break;

      default:
        logger.log("default", msgObject);
        break;
    }
  };

  toggleIsAutoOn = (b) => {
    this.setState({ isAutoOn: b });
    if (!b) clearTimeout(this.myTimeout);
  };

  handleBetAmount = (b) =>
    this.setState({ betInfo: this.state.betInfo, betAmount: b });
  handleBetReply = (obj) => this.setState({ betReplyData: obj });

  handleSelected = (s) => this.setState({ selected: s });
  clearWonBalls = () =>
    this.setState((prevState) => {
      let betinf5 = prevState.betInfo;
      betinf5.numbers = [];
      return { ...prevState, betinf5 };
    });
  handleAutoRollLogic = (a) => {
    this.clearWonBalls();
    let max = 100; // TODO
    let {
      numberOfBets,
      onWinReset,
      onWinPercent,
      onLossReset,
      onLossPercent,
      stopOnProfit,
      stopOnLoss,
      useBet,
    } = a;

    this.autorollLogic.setSettings(
      useBet,
      max,
      onLossReset,
      onLossPercent,
      onWinReset,
      onWinPercent,
      stopOnLoss,
      stopOnProfit,
      numberOfBets,
    );
    this.props.handleAutoRulesConfigs({
      numberOfBets,
      onWinReset,
      onWinPercent,
      onLossReset,
      onLossPercent,
      stopOnProfit,
      stopOnLoss,
    });
    this.props.handleBet(useBet);
    this.setState({
      autoRulesConfigs: a,
      isAutoOn: true,
      betInfo: {
        ...this.state.betInfo,
        selectedNumbers: [],
        numbers: [],
        winNumbers: [],
      },
    });
    if (this.state.selected.length > 0) {
      this.props.saveSettings(useBet);
      placeBet(+useBet, this.state.selected.join(":"));
    }
  };

  kenoFadeInHandler = (g) => {
    this.setState({ gameMode: g });
    Globals.WS = new WS().Init(this).Start();
  };
  handleNotification = (n) => {
    // if (!n) {
    //   this.setState({ notificationfadeOut: true });
    //   clearTimeout(this.notificationTimeOut);
    //   setTimeout(() => {
    //     this.setState({ notification: n, notificationfadeOut: false });
    //   }, 333);
    // }
    if (!!n) {
      this.setState({ notification: n });
      clearTimeout(this.notificationTimeOut);
      this.notificationTimeOut = setTimeout(() => {
        this.setState({ notificationfadeOut: true });
        setTimeout(() => {
          this.setState({ notification: false, notificationfadeOut: false });
        }, 333);
      }, 1666);
    }
  };
  handleVolume = (v) => this.setState({ volume: +v });

  handleResize = (a) => {
    const { lastWidth, lastHeight } = this.state;
    logger.log(window.orientation);
    this.setState({ scrollable: false });

    if (window.innerHeight < 667) {
      if (
        !(window.innerWidth === lastWidth && window.innerHeight === lastHeight)
      ) {
        if (
          window.innerWidth === lastWidth &&
          window.innerHeight < lastHeight - 100
        ) {
          this.setState({ scrollable: true });
        } else {
          this.setState({
            lastHeight: window.innerHeight,
            lastWidth: window.innerWidth,
            intViewportHeight: window.innerHeight,
          });
        }
      }
    }
  };


  render() {
    const { changingMode } = this.props;
    const {
      isLoaded,
      startKeno,
      fadeInKeno,
      showLoading,
      isShaking,
      isShakingPurple,
      coordinates,
      betInfo,
      isAutoOn,
      selected,
      stats,
      myHistory,
      allHistory,
      highRoller,
      user_id,
      autoRulesConfigs,
      notification,
      notificationfadeOut,
      gameState,
      toFix,
      noSignal,
      errorBtn,
      errorMsg,
      reload,
      sound,
      music,
      volume,
      scrollable,
      intViewportHeight,
      rotateNow,
      betReplyData,
      makeClickable,
    } = this.state;

    return (
      <AppContainer
        className="AppContainer"
        onContextMenu={(e) => e.preventDefault()}
        rotateNow={rotateNow}
      >
        {!!noSignal && !!changingMode ? (
          <NoSignal
            Globals={this.Globals}
            errorMsg={errorMsg}
            errorBtn={errorBtn}
            reload={reload}
            sound={sound}
          />
        ) : (
          <>
            {startKeno && (
              <Keno
                fadeInKeno={fadeInKeno}
                showLoading={showLoading}
                user_id={user_id}
                betInfo={betInfo}
                isAutoOn={isAutoOn}
                selectedFromApp={selected}
                history={{ myHistory, allHistory, highRoller }}
                stats={stats}
                clearWonBalls={this.clearWonBalls}
                toggleIsAutoOn={this.toggleIsAutoOn}
                handleBetAmount={this.handleBetAmount}
                handleSelected={this.handleSelected}
                handleAutoRollLogic={this.handleAutoRollLogic}
                autorollLogic={this.autorollLogic}
                autoConfigs={autoRulesConfigs}
                handleNotification={this.handleNotification}
                gameState={gameState}
                toFix={toFix}
                currency={gameState.currency}
                sound={sound}
                // toggleSound={this.toggleSound}
                music={music}
                // toggleMusic={this.toggleMusic}
                volume={volume}
                handleVolume={this.handleVolume}
                intViewportHeight={intViewportHeight}
                scrollable={scrollable}
                betReplyData={betReplyData}
                handleBetReply={this.handleBetReply}
                makeClickable={makeClickable}
              />
            )}

            {notification && (
              <Notification
                notifyText={notification}
                fadeOut={notificationfadeOut}
                handleNotification={this.handleNotification}
                volume={volume}
                sound={sound}
              />
            )}
            {showLoading && (
              <Loading
                isLoaded={isLoaded}
                isShaking={isShaking}
                isShakingPurple={isShakingPurple}
                coordinates={coordinates}
                volume={volume}
                sound={sound}
                music={music}
                kenoFadeIn={this.kenoFadeInHandler}
              />
            )}
          </>
        )}
      </AppContainer>
    );
  }
}

const mapStateToProps = (state) => state;
const mapDispatchToProps = (dispatch) => {
  return {
    handleGameState: (i) => dispatch(handleGameState(i)),
    handleBetInfo: (i) => dispatch(handleBetInfo(i)),
    handleSettings: (i) => dispatch(handleSettings(i)),
    handleAutoRulesConfigs: (i) => dispatch(handleAutoRulesConfigs(i)),
    handleBet: (i) => dispatch(handleBet(i)),
    saveSettings: (i) => dispatch(saveSettings(i)),
    toggleChangingMode: (i) => dispatch(toggleChangingMode(i)),
    getSeedsResponce: (i) => dispatch(getSeedsResponce(i)),
    handleBetReplay: (i) => dispatch(handleBetReplay(i)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
